import React from 'react';
import { Tooltip } from 'antd';
import { apiHolder, apis } from 'api';
import classnames from 'classnames';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import DeleteTag from '@web-common/components/UI/Icons/svgs/DeleteTagSvg';
import { verifyEmail } from '../../../util';
import styles from '../../Selector/selector.module.scss';
import praiseStyles from './praiseMail.module.scss';
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const ContactChip = props => {
    const { value, item, onClose } = props;
    const email = contactApi.findContactInfoVal(item.contactInfo || []) || value;
    const truncateValue = (email === null || email === void 0 ? void 0 : email.length) > 20 ? `${email.slice(0, 18)}...` : email;
    const correctEmail = verifyEmail(email === null || email === void 0 ? void 0 : email.trim());
    let children;
    if (!correctEmail) {
        children = (React.createElement("div", { className: classnames(styles.capsuleTag, {
                [styles.capsuleTagWrong]: true,
                'contact-tag': true,
            }) },
            React.createElement("span", { className: classnames([styles.charAvatar, styles.charAvatarWrong]) }, "!"),
            React.createElement("span", { className: classnames([styles.label, styles.labelWrong]) }, truncateValue)));
    }
    else if (!item) {
        children = (React.createElement("div", { className: classnames(styles.capsuleTag, {
                'contact-tag': true,
            }) },
            React.createElement(AvatarTag, { style: { display: 'inline-block' }, size: 20, propEmail: email, user: {
                    name: value,
                    color: '#ffaa00',
                } }),
            React.createElement("span", { className: styles.label }, truncateValue)));
    }
    else {
        const { contact: { contactName, avatar, color, id }, } = item;
        const truncateName = (contactName === null || contactName === void 0 ? void 0 : contactName.length) > 20 ? `${contactName.slice(0, 18)}...` : contactName;
        children = (React.createElement("div", { data: email, className: classnames(styles.capsuleTag, { 'contact-tag': true }) },
            React.createElement(AvatarTag, { size: 20, contactId: id, propEmail: email, user: {
                    name: contactName,
                    avatar,
                    color,
                } }),
            React.createElement("span", { className: styles.label }, truncateName)));
    }
    return (React.createElement(Tooltip, { title: correctEmail ? email : `${email}（邮箱格式错误）`, destroyTooltipOnHide: true, placement: "bottomLeft", overlayClassName: "selector-tag-tooltip" },
        React.createElement("div", { className: praiseStyles.tagWrapper },
            onClose ? (React.createElement("div", { className: praiseStyles.tagCloseBtn, onClick: onClose },
                React.createElement(DeleteTag, null))) : null,
            children)));
};
export default ContactChip;
